/**
 * @file src/types.ts
 * @exports SearchTypeEnum, SortKey, StringBooleanType, TableSortState, UserRoleEnum
 * @summary Shared application types, including the package search type used for identity re-check invites.
 */

import type { SortOrder } from "./generated/graphql";
import { NameSortOrder } from "./views/Invites/types";

export enum SearchTypeEnum {
	IdentityRecheck = "identityRecheck",
}

export enum UserRoleEnum {
	SuperAdmin = "SUPER_ADMIN",
	OrganizationAdmin = "ORGANIZATION_ADMIN",
	User = "USER",
	IntegrationAdmin = "INTEGRATION_ADMIN",
	Processor = "PROCESSOR",
	CerebrumTeam = "CEREBRUM_TEAM",
	CraAdmin = "CRA_ADMIN",
}

export type SortKey = string;

export interface TableSortState {
	sortKey: SortKey;
	sortValue: SortOrder | NameSortOrder;
}

export type StringBooleanType = {
	[key: string]: boolean;
};
